import { Controller } from 'stimulus'

export default class extends Controller {

  initialize() {
    new isvek.Bvi({ builtElements: true, reload: true, panelFixed: false })
  }
}
